import React, { Component } from "react";
//
import {
    withStyles,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@material-ui/core";

const styles = theme => ({
    dialog: {
        padding: theme.spacing(1),
    },
    message: {
        padding: theme.spacing(1),
        whiteSpace: "pre-line"
    }
});

class Info extends Component {
    render() {
        const { classes, type, message, open } = this.props;
        let messages;

        if (Array.isArray(message)) {
            messages = message.map((message, index) => ({
                id: index,
                content: message
            }));
        } else {
            messages = [{ id: 0, content: message }];
        }

        return (
            <Dialog
                fullWidth
                maxWidth="xs"
                open={open && !!message}
                onClose={this.handleClose}
                PaperProps={{
                    className: classes.dialog
                }}
            >
                <DialogTitle>
                    {type}
                </DialogTitle>
                <DialogContent>
                    {messages.map((message) => (
                        <Typography key={message.id} className={classes.message} align="justify">
                            {message.content}
                        </Typography>
                    ))}
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={this.props.onClose}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(styles, { withTheme: true })(Info);
